import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export interface OverviewStats {
  devicesOnline: number;
  devicesTotal: number;
  devicesPending: number;
  sessionsActive: number;
  usersActive: number;
  sessionsToday: number;
  sessionsYesterday: number;
  bytesTransferredToday: string;
}

export function useOverview() {
  return useQuery({
    queryKey: ['stats', 'overview'],
    queryFn: () => api.get<OverviewStats>('/stats/overview'),
    // Refresh every 30s in background — the dashboard should feel "live"
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
}

export interface ActivityBucket {
  hour: string;
  sessions: number;
}

export function useSessionsActivity() {
  return useQuery({
    queryKey: ['stats', 'sessions-activity'],
    queryFn: () => api.get<{ data: ActivityBucket[] }>('/stats/sessions-activity'),
    refetchInterval: 60_000,
  });
}

export interface TechnicianStats {
  userId: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  sessionsCount: number;
  totalDurationSec: number;
}

export function useTopTechnicians(limit = 5) {
  return useQuery({
    queryKey: ['stats', 'top-technicians', limit],
    queryFn: () => api.get<{ data: TechnicianStats[] }>(`/stats/top-technicians?limit=${limit}`),
  });
}
